import { render, staticRenderFns } from "./NewCustomFieldLabel.vue?vue&type=template&id=485b45f4&"
import script from "./NewCustomFieldLabel.vue?vue&type=script&lang=js&"
export * from "./NewCustomFieldLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('485b45f4')) {
      api.createRecord('485b45f4', component.options)
    } else {
      api.reload('485b45f4', component.options)
    }
    module.hot.accept("./NewCustomFieldLabel.vue?vue&type=template&id=485b45f4&", function () {
      api.rerender('485b45f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverableTemplates/NewCustomFieldLabel.vue"
export default component.exports